import { Inject, Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from 'core/config/config.service';

@Pipe ({ name: 'priceFormat' })
export class PriceFormatPipe implements PipeTransform
{
  private locale: string;
  private priceFormat: Intl.NumberFormatOptions;

  constructor(@Inject(ConfigService) configService: ConfigService)
  {
    let productDesignerComponentConfig =
        configService.getProductDesignerComponentConfig();

    this.priceFormat = productDesignerComponentConfig.priceFormat;
    this.locale = productDesignerComponentConfig.locale;
  }

  public transform (price: string): String
  {
    const number = Number(price);
    try {
      return new Intl.NumberFormat(this.locale, this.priceFormat)
        .format(number);
    } catch (error) {
      return number.toString();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/price/price-format.pipe.ts